import {Component, OnInit} from '@angular/core';
import {ProductListComponentService, SearchCriteria} from '@spartacus/storefront';
import {ProductSearchPage} from '@spartacus/core';
import {Observable} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {CustomScrollingService} from '@app/services/custom-scrolling.service';
import {DcpEddlSearchTrackingService} from '@app/services/analytics/EDDL/dcp-eddl-search-tracking.service';

@Component({
  selector: 'dcp-search-pagination',
  templateUrl: './search-pagination.component.html',
})
export class SearchPaginationComponent implements OnInit {

  model$: Observable<ProductSearchPage>;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected router: Router,
    private productListComponentService: ProductListComponentService,
    private customScrollingService: CustomScrollingService,
    private eddlSearchTrackingService: DcpEddlSearchTrackingService
  ) {
  }

  ngOnInit(): void {
    this.model$ = this.productListComponentService.model$;
  }

  viewPage(pageNumber: number): void {
    this.route({currentPage: pageNumber});
  }

  protected route(queryParams: SearchCriteria): void {
    this.eddlSearchTrackingService.sortFilterOrPaginationHitEvent = true;
    this.router.navigate([], {
      queryParams,
      queryParamsHandling: 'merge',
      relativeTo: this.activatedRoute,
    }).then(isNavigatedSuccessfully => {
      if (isNavigatedSuccessfully) {
        this.customScrollingService.scrollTop();
      }
    });
  }
}
